// Module
var code = `<div class="text-center">
	<h3 class="mb-0">
		No {{ctrl.no || 'content'}}
		<br/><small class="text-muted">Go add some!</small>
	</h3>
</div>
`;
// Exports
export default code;